import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Typography";
import { useStyles } from "./styles";

interface DeleteConfirmationModalProps {
  handelOnCancelConfirmationModal: () => void;
  handleOnClickProceedToDeleteAccount: () => void;
}

export default function DeleteConfirmationModal({
  handelOnCancelConfirmationModal,
  handleOnClickProceedToDeleteAccount,
}: DeleteConfirmationModalProps) {
  const classes = useStyles();

  return (
    <Box
      style={{
        zIndex: 9999,
        position: "fixed", // Fix the position of the container
        top: 0, // Align with the top of the viewport
        left: 0, // Align with the left of the viewport
        right: 0, // Align with the right of the viewport
        bottom: 0, // Align with the bottom of the viewport
        display: "flex", // Use flexbox to center the inner content
        alignItems: "center", // Center vertically
        background: "rgba(162, 161, 168, 0.20)",
        backdropFilter: "blur(10px)",
      }}
    >
      <div
        style={{
          margin: "auto",
          marginTop: "20vh",
          background: "#F5F5F5",
          borderRadius: 10,
          padding: "25px",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch", // Allow child elements to stretch to the container's width
          maxWidth: "570px", // Set a fixed width for the popup if desired
          width: "85%",
        }}
      >
        <Typography
          component="h1"
          variant="h4"
          display="block"
          gutterBottom
          style={{
            color: "#16151C",
            fontWeight: 400,
          }}
        >
          Deleting or deactivating your account is irreversible. Are you sure
          you want to proceed?"
        </Typography>

        <div
          style={{
            marginTop: 15,
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            alignItems: "stretch", // Allow buttons to take full width
          }}
        >
          <Button
            onClick={handelOnCancelConfirmationModal}
            variant="outlined"
            color="primary"
            className={classes.submit}
            style={{
              height: 42,
              maxWidth: 150,
              width: "100%", // Make button take full width of its container
              borderRadius: 10,
              marginRight: "10px",
              marginBottom: "0px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleOnClickProceedToDeleteAccount}
            variant="contained"
            color="primary"
            className={classes.submit}
            style={{
              height: 42,
              maxWidth: 150,
              width: "100%", // Make button take full width of its container
              borderRadius: 10,
              marginBottom: "0px",
            }}
          >
            Proceed
          </Button>
        </div>
      </div>
    </Box>
  );
}
